
import React, { useEffect } from 'react';
import OnboardingFlow from './OnboardingFlow';
import { PageLayout } from '@/components/layout';

const NewUserOnboarding: React.FC = () => {
  // ScrollToTop component handles page scroll positioning

  return (
    <PageLayout 
      title="Get Started in 3 Easy Steps" 
      maxWidth="max-w-6xl"
    >
      <OnboardingFlow />
    </PageLayout>
  );
};

export default NewUserOnboarding;
